import useSWR from 'swr';

import axiosInstance from '../../../http/axios-instance';
import { swrConfig } from '../../../http/swr-config';
import { Account } from '../../session/session-decode';
import { Locale } from '../core/locale';
import { LoggedPerson } from '../core/pessoa-nome';

/**
 * GET pessoas/pessoa_logada; `key` null quando `enabled` é falso desabilita o
 * fetch (integrador/distribuidor não precisam da pessoa logada).
 */
export function useLoggedPerson(enabled: boolean): {
  person: LoggedPerson | null;
  isLoading: boolean;
} {
  const { data, isLoading } = useSWR<LoggedPerson>(
    enabled ? 'pessoas/pessoa_logada' : null,
    swrConfig,
  );

  return { person: data ?? null, isLoading };
}

/** GET admin/tenants/integrador; só busca quando `enabled` (usuário integrador). */
export function useIntegratorAccounts(enabled: boolean): {
  accounts: Account[] | null;
  isLoading: boolean;
} {
  const { data, isLoading } = useSWR<Account[]>(
    enabled ? 'admin/tenants/integrador' : null,
    swrConfig,
  );

  return { accounts: data ?? null, isLoading };
}

/** GET public/locale/all/; sempre habilitado. `[]` em ausência/falha (nunca null). */
export function useLocales(): { locales: Locale[]; isLoading: boolean } {
  const { data, isLoading } = useSWR<Locale[]>('public/locale/all/', swrConfig);

  return { locales: data ?? [], isLoading };
}

/**
 * Mutação (fora do SWR): persiste o idioma do usuário. Resolve em sucesso,
 * rejeita em falha — o hook consumidor decide o toast.
 */
export async function changeLocale(locale: Locale): Promise<void> {
  await axiosInstance.post('public/locale/usuario/', locale);
}
